import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "section section-tertiary mt-0 mb-0" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col" }
const _hoisted_5 = { class: "breadcrumb breadcrumb-style-1 d-block text-4 mb-4" }
const _hoisted_6 = {
  key: 0,
  class: "text-color-primary ext-decoration-none"
}
const _hoisted_7 = {
  key: 1,
  class: "text-color-light text-color-hover-primary text-decoration-none"
}




export default /*#__PURE__*/_defineComponent({
  __name: 'BreadCrumb',
  props: {
  menus: Array,
},
  setup(__props) {

const props = __props;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("ul", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.menus, (menu, index) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: menu.id
              }, [
                (index === __props.menus?.length - 1)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_6, [
                      _createElementVNode("strong", null, _toDisplayString(menu?.title), 1)
                    ]))
                  : (_openBlock(), _createElementBlock("li", _hoisted_7, _toDisplayString(menu?.title), 1))
              ], 64))
            }), 128))
          ])
        ])
      ])
    ])
  ]))
}
}

})